import React,{useState,useEffect,useRef} from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
    Box,Input,
    Button,
    Flex,
    Form, Table,
    TableCaption,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    } from '@chakra-ui/react';


const PurchaseReport=()=>{
    const [data,setData]=useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState(new Date());
    
    const customerId=localStorage.getItem('customerId')
    const fetchData=async()=>{
        try {
            const response=await axios.get(`https://api.hotel.tdrsoftware.in/api/getPurchaseBill/${customerId}?startDate=${startDate}&endDate=${endDate}`)
            toast.success(response.data.message);
            console.log(response)
            setData(response.data.purchaseFilter)
            setFilteredData(response.data.purchaseFilter)
        } catch (error) {
            toast.error(error.message);
        }
    }
    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
      
    };
  
    const handleStartDateChange = (event) => {
      setStartDate(event.target.value);
     
    };
  
    const handleEndDateChange = (event) => {
      setEndDate(event.target.value);
     
    };
    const exportToExcel = () => {
     
      const excelData = filteredData.map((purchase) => ({
        Name: purchase.name,
              BillNo: purchase.billNo,
              Store: purchase.store,
              Date: purchase.date,
              Address: purchase.address,
              GrossAmount: purchase.grossAmount,
              NetAmount: purchase.netAmount,
              ChallanNo: purchase.challanNo,
              InvoiceNo: purchase.invoiceNo,
              
        // Other Guests Info
        PuchaseItems: purchase.item?.map((guest, index) => 
          ` ${index + 1}: Name-${guest.itemName}, Qty-(${guest.quantity}),Unit-(${guest.unit}),MRP-(${guest.mrp}),PurchaseRate-(${guest.purchaseRate}),Discount-(${guest.discount}),SGST-(${guest.sgst}),CGST-(${guest.cgst}),Amount-(${guest.amount})`
        ).join("; ")
      }));
  
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'PurchaseData');
    
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }) ;
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' }) ;
      saveAs(data, 'PurchaseData.xlsx');
    };
    
  
    useEffect(()=>{
        fetchData()
    },[customerId,startDate,endDate])
    return (
        <Box>
        <Box>
           {/* <Input
          w='40%'
          type="text"
          placeholder="Search by Registration or Room No"
          value={searchTerm}
          onChange={handleSearchChange}
        /> */}
        <Input
          w='20%'
          type="date"
          placeholder="Start Date"
          value={startDate}
          
          onChange={handleStartDateChange}
          mr={2}
        />
        <Input
          w='20%'
          type="date"
          placeholder="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          mr={2}
        />
        <Button onClick={exportToExcel} colorScheme='blue' mr={2}>Export to Excel</Button>
      </Box>
               <TableContainer width='100vw - 250px'>
        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Food Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Date</Th>

              <Th>Adress</Th>
              <Th>Balance</Th>
              <Th>Bill No</Th>
              <Th>Challan No</Th>
              <Th>Invoice No</Th>
              <Th>Items</Th>
              <Th>Store</Th>
              <Th>CGST</Th>
              <Th>SGST</Th>
              <Th>Discount</Th>
              <Th>Discount(%)</Th>
              <Th>Total Tax</Th>
              <Th>Gross Amount</Th>
              <Th>Net Amount</Th>
             
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((item, index) => (
              <Tr key={index}>
                <Td>{item.name}</Td>
                <Td>{item.date}</Td>
                <Td>{item.address}</Td>
                <Td>{item.balance}</Td>
                <Td>{item.billNo}</Td>
                <Td>{item.challanNo}</Td>
                <Td>{item.invoiceNo}</Td>
                <Td><Table size='sm' variant='striped' colorScheme='blue'>
                    <TableCaption>Item Data</TableCaption>
                    <Thead>
                    <Tr>
                    <Th>Name</Th>
                    <Th>Quantity</Th>
                    <Th>Unit</Th>
                    <Th>Mrp</Th>
                    <Th>Purchase Rate</Th>
                    <Th>Cgst</Th>
                    <Th>Sgst</Th>
                    <Th>Amount</Th>
                    </Tr>
                    </Thead>
                    <Tbody>
                    {item.item.map((item, index) => (
                    <Tr key={index}>
                    <Td>{item.itemName}</Td>
                    <Td>{item.quantity}</Td>
                    <Td>{item.unit}</Td>
                    <Td>{item.mrp}</Td>
                    <Td>{item.purchaseRate}</Td>
                    <Td>{item.cgst}</Td>
                    <Td>{item.sgst}</Td>
                    <Td>{item.amount}</Td>
                    </Tr>))}
                    </Tbody>
                </Table></Td>
                <Td>{item.store}</Td>
                <Td>{item.cgstTotal}</Td>
                <Td>{item.sgstTotal}</Td>
                <Td>{item.cashDiscountAmount}</Td>
                <Td>{item.cashDiscountPercentage}</Td>
                <Td>{item.totalTax}</Td>
                <Td>{item.grossAmount}</Td>
                <Td>{item.netAmount}</Td>

               
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
        </Box>
    )
}
export default PurchaseReport
